export const KEY_REMEMBER_DEFAULT_SELECTED_ORGANIZATION_ACCOUNT =
  "KEY_REMEMBER_DEFAULT_SELECTED_ORGANIZATION_ACCOUNT";

export const KEY_SELECTED_ORGANIZATION_ACCOUNTS =
  "KEY_SELECTED_ORGANIZATION_ACCOUNTS";
